
<template>
  <section id="PropertyFacilities">
    <h2 class="text-title-2 fw-semi-bold">{{$t('Facilities')}}</h2>
    <div class="container pt-1">
      <div class="facilities-container">
        <div class="facilities-container__item" v-if="fullCancellation.period">
          <img src="/images/check-one.svg" alt="" aria-hidden="true">
          <span>{{ $t('Free cancellation') }}</span>
        </div>
        <div class="facilities-container__item" v-if="property.voucher_type">
          <img src="/images/mobile.svg" alt="" aria-hidden="true">
          <span>{{getTicketTypeLabel(property.voucher_type)}}</span>
        </div>
        <div class="facilities-container__item" v-if="property.duration">
          <img src="/images/time.svg" alt="" aria-hidden="true">
          <span>{{duration(property.duration)}}</span>
        </div>
        <div class="facilities-container__item" v-if="property.available_languages">
          <img src="/images/globe.svg" alt="" aria-hidden="true">
          <span>{{ $t('Available in {languages}', { languages: property.available_languages }) }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useActivityPropertyStore } from "~/store/activityProperty";
import dayjs from '~/utils/dayjs'
const property = useActivityPropertyStore().property

const fullCancellation = computed(() => {
  const cancellations = property.cancellation_policies
  return cancellations?.find((cancellation: any) => {return cancellation.refund_value == 100 && cancellation.refund_type == 'percentage'}) || {}
})

function duration(time: number) {
  return dayjs.duration(time * 1000).humanize()
}

const getTicketTypeLabel = (voucher_type:string) => {
  return voucher_type === 'mixed' ? 'Mobile voucher accepted' : voucher_type
}
</script>

<style scoped lang="scss">
.facilities-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  &__item {
    width: 40%;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
.property-amenities {
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;

  &--others {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 24px;
  }
  .amenity {
    display: flex;
    font-size: 14px;
    gap: 8px;
    align-items: flex-start;

    @media screen and (max-width: 430px) {
      width: calc(50% - 24px);
      font-weight: 400;
      line-height: 20px;
    }
    .icon {
      padding-top: 2px;
      font-size: 16px;
    }
  }
}

.amenities-more-button {
  white-space: nowrap;
  padding: 10px 20px;
  height: 40px;
  margin-top: 24px;

  //tablet
  @media screen and (max-width: 1024px) and (min-width: 768px){
    white-space: nowrap;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    margin-top: 20px;
  }

  .icon {
    font-size: 16px;

    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
}

//modal

:global(.modal-container) {
  width: 100%;
  max-width: 708px;
  height: 100%;
  max-height: 100%;
  padding: 24px 32px;
  overflow-y: auto;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
}



.dialog-header-wrapper {
  display: flex;

  @media screen and (max-width: 768px) {
    align-items: center;
    gap: 24px;
  }
}

.dialog-info-header {
  line-height: 1.1;
  align-items: center;
  display: flex;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
}

.dialog-body {
  h2 {
    color: var(--black);
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    padding-bottom: 16px;
    padding-top: 24px;
  }
}
</style>
